<template>
  <div>
    <div class="qr-code" :id="refStr"></div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2-fix";

export default {
  props: {
    rightUrl: {
      type: String,
      default: ''
    },
    refStr: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 150
    },
    height: {
      type: Number,
      default: 150
    }
  },
  watch:{
    rightUrl(newval,oldval){
      this.init()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    });
  },
  methods: {
    init(){
      const qrcodeDom = document.getElementById(this.refStr);
      qrcodeDom.innerHTML = ''
      new QRCode(qrcodeDom, {
        text: this.rightUrl, // 二维码的内容
        width: this.width,
        height: this.height,
        colorDark: "#000",
        colorLight: "#fff",
        correctLevel: QRCode.CorrectLevel.H
      });
    }
  }
}
</script>

<style>

</style>